
import { HistoryComponent } from './../history/history.component';
import { Component, OnInit, Input } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
 
export interface alerthistoryModel{
  title:any;
  values:any[];
  contractlevelArr:any[];
  finalArr:any[];
  customIndex:number;


}
@Component({
  selector: 'app-alert-history',
  templateUrl: './alert-history.component.html',
  styleUrls: ['./alert-history.component.scss']
})

export class AlertHistoryComponent  extends DialogComponent<alerthistoryModel,null>{

  constructor(dialogservice:DialogService) {
    super(dialogservice);
  }

  ngOnInit() {
    
    console.log(this.dialogService);
  }

}



// WEBPACK FOOTER //
// ./client/app/alert-history/alert-history.component.ts